import { useCallback } from 'react'
import Project from 'common/project'
import _data from 'common/utils/_data'


export const useViewCounts = () => {
 const increaseView = useCallback(
    async (id:string) => {
      try {
        const  data  = await _data.post(
            `${Project.liveApi}legal-services/lawyers/increment-views/${id}/`,
          );
        return data; 
      } catch (error) {
        console.error("Error in increase view:", error);
        return {}; 
      }
    },
    [],
  );
  return {
   increaseView
  }
}